import { render, staticRenderFns } from "./CaTotalGraph.vue?vue&type=template&id=3fa2c462&"
import script from "./CaTotalGraph.vue?vue&type=script&lang=ts&"
export * from "./CaTotalGraph.vue?vue&type=script&lang=ts&"
import style0 from "./CaTotalGraph.vue?vue&type=style&index=0&id=3fa2c462&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports